import { Select } from 'antd'
import { useTranslation } from 'react-i18next'

import { useDashboardFilters } from '@contexts'
import { useSuppliers } from '@hooks'

import { FilterGroup } from './styled'

const SupplierSelector = () => {
  const { t } = useTranslation()
  const { supplierId, setSupplierId } = useDashboardFilters()
  const { suppliersOptions, isLoading } = useSuppliers({ disabled: false })

  return (
    <FilterGroup>
      <Select
        allowClear
        showSearch
        optionFilterProp="label"
        loading={isLoading}
        style={{ minWidth: 200 }}
        placeholder={t('admin_router.dashboard.filter_supplier_all')}
        aria-label={t('admin_router.dashboard.filter_supplier')}
        options={suppliersOptions}
        value={supplierId}
        onChange={value => setSupplierId(typeof value === 'number' ? value : undefined)}
      />
    </FilterGroup>
  )
}

export { SupplierSelector }
